module.exports = __webpack_public_path__ + "static/logo-caption-6b2e3d2322391e244fd92ad51779eae9.png";